import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';


import '../assets/css/lineicons.css';
import '../assets/css/datepicker.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/swiper2.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style2.css';
import '../assets/css/globalStyles.css';


import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Slider from '../components/Slider';

// Import images
import logoTripadvisor from '../assets/images/logo-tripadviser.png';
import sideImage03 from '../assets/images/side-image03.webp';
import sideImage from '../assets/images/aboutus/side.webp';
import sideOne from '../assets/images/aboutus/side_one.webp';
import sideTwo from '../assets/images/aboutus/side_two.webp';
import introImage from '../assets/images/home/intro.webp';
import loversLeapImage from '../assets/images/home/loversleap.webp';
import lakeImage from '../assets/images/home/lake.webp';
import moonPlainsImage from '../assets/images/home/moonplains.webp';
import golfImage from '../assets/images/home/golf.webp';
import horseImage from '../assets/images/home/horse.webp';
import hakgalaImage from '../assets/images/home/hakgala.webp';
import teaImage from '../assets/images/home/Tea.webp';
import teaFactoryImage from '../assets/images/home/teafactory.webp';

// Import facility images
import facility1 from '../assets/images/facilities/1.webp';
import facility2 from '../assets/images/facilities/2.webp';
import facility3 from '../assets/images/facilities/3.webp';
import facility4 from '../assets/images/facilities/4.webp';
import facility5 from '../assets/images/facilities/5.webp';
import facility6 from '../assets/images/facilities/6.webp';

// Import mobile facility images
import facility1Mobile from '../assets/images/facilities/mobile/1.webp';
import facility2Mobile from '../assets/images/facilities/mobile/2.webp';
import facility3Mobile from '../assets/images/facilities/mobile/3.webp';
import facility4Mobile from '../assets/images/facilities/mobile/4.webp';
import facility5Mobile from '../assets/images/facilities/mobile/5.webp';
import facility6Mobile from '../assets/images/facilities/mobile/6.webp';

// Import room images
import kingSuiteImage from '../assets/images/rooms/kingsuite/gallery1.webp';
import kingRoomImage from '../assets/images/rooms/kingroom/gallery1.webp';
import doubleRoomImage from '../assets/images/rooms/doubleroom/gallery3.webp';
import twinRoomImage from '../assets/images/rooms/twinroom/gallery1.webp';

// Import mobile room images
import kingSuiteImageMobile from '../assets/images/rooms/kingsuite/gallery1_m.webp';
import kingRoomImageMobile from '../assets/images/rooms/kingroom/gallery1_m.jpg';
import doubleRoomImageMobile from '../assets/images/rooms/doubleroom/gallery1_m.jpg';
import twinRoomImageMobile from '../assets/images/rooms/twinroom/gallery1_m.webp';

const Home = () => {
  // Refs for the swiper instances
  const roomsSliderRef = useRef(null);
  const facilitiesSliderRef = useRef(null);
  const roomsSliderMobileRef = useRef(null);
  const facilitiesSliderMobileRef = useRef(null);
  const adventureSliderRef = useRef(null);
  const datepickerRef = useRef(null);
  const calendarIconRef = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY;
      const navbar = document.querySelector('.navbarzzz');
      if (navbar) {
        navbar.style.backgroundColor = scroll > 0 ? '#722628' : 'transparent';
      }
    };
  
    window.addEventListener('scroll', handleScroll);
  
    const handleIconClick = () => {
      if (window.$ && datepickerRef.current) {
        window.$(datepickerRef.current).datepicker('show');
      }
    };
  
    const initDatepicker = () => {
      if (window.$ && window.$.fn.datepicker && datepickerRef.current) {
        const $datepickerInput = window.$(datepickerRef.current);
  
        // Prevent reinitialization
        if (!$datepickerInput.data('datepicker')) {
          $datepickerInput.datepicker({
            format: 'mm/dd/yyyy',
            autoHide: true,
            container: 'body',
            zIndex: 2048,
          });
        }
        
        // Store the reference to the current element
        const currentCalendarIcon = calendarIconRef.current;

        // Icon click opens datepicker
        if (currentCalendarIcon) {
          currentCalendarIcon.addEventListener('click', handleIconClick);
        }
      } else {
        setTimeout(initDatepicker, 500);
      }
    };
  
    initDatepicker();
  
    // Swiper init code for desktop
    if (roomsSliderRef.current) {
      new Swiper(roomsSliderRef.current, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: null,
          prevEl: null,
        },
        breakpoints: {
          1024: { spaceBetween: 30 },
          768: { slidesPerView: 1, spaceBetween: 0 },
          640: { slidesPerView: 1, spaceBetween: 0 },
          320: { slidesPerView: 1, spaceBetween: 0 },
        }
      });
    }
  
    if (facilitiesSliderRef.current) {
      new Swiper(facilitiesSliderRef.current, {
        modules: [Navigation, Pagination],
        slidesPerView: 4,  // Changed from 3 to 4
        spaceBetween: 10,  // Reduced space between slides
        loop: false,
        navigation: {
          nextEl: null,
          prevEl: null,
        },
        breakpoints: {
          1200: { slidesPerView: 4 },  // Show 4 on large screens
          992: { slidesPerView: 3 },   // Show 3 on medium screens
          768: { slidesPerView: 2 },   // Show 2 on small screens
          320: { slidesPerView: 1 },   // Show 1 on mobile
        }
      });
    }
  
    // Swiper init code for mobile views
    if (roomsSliderMobileRef.current) {
      new Swiper(roomsSliderMobileRef.current, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: null,
          prevEl: null,
        },
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true
      });
    }
  
    if (facilitiesSliderMobileRef.current) {
      new Swiper(facilitiesSliderMobileRef.current, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: null,
          prevEl: null,
        },
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true
      });
    }
  
    if (adventureSliderRef.current) {
      new Swiper(adventureSliderRef.current, {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
        breakpoints: {
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          640: { slidesPerView: 1 },
          320: { slidesPerView: 1 },
        }
      });
    }
  
    // Capture the current value of calendarIconRef at the time the effect runs
    const capturedCalendarIcon = calendarIconRef.current;
  
    return () => {
      window.removeEventListener('scroll', handleScroll);
  
      // Use the captured value instead of calendarIconRef.current
      if (capturedCalendarIcon) {
        capturedCalendarIcon.removeEventListener('click', handleIconClick);
      }
    };
  }, []);

  return (
    <div className="example">
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <meta name="theme-color" content="#722628" />
        <title>
          Kent Cottage Nuwara Eliya | Boutique Hotels and Leisure, Sri Lanka | Oryza
          Leisure
        </title>
        <meta name="author" content="Ollcode" />
        <meta
          name="description"
          content="A luxury cottage with beautiful views of the tea estates and hills of Nuwara Eliya situated in Little England, Nuwara Eliya, Sri Lanka."
        />
        <meta
          name="keywords"
          content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, vip"
        />
      </Helmet>
      
      <div className="cursor js-cursor"></div>
      
      <Navbar />
      
      <main id="main">
        <Slider />

        <section className="content-section no-spacing kentbg desktopview">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="hotel-search">
                  <h6 className="whitetext">ROOMS & SUITES</h6>
                  <form action="https://live.ipms247.com/booking/book-rooms-kentcottagenuwaraeliya" target="_blank">
                    <div className="form-group">
                      <label className="whitetext">Check-In / Check-Out</label>
                      <input 
                        ref={datepickerRef}
                        type="text" 
                        placeholder="Select Dates" 
                        data-toggle="datepicker" 
                        className="date"
                        readOnly
                      />
                      <i ref={calendarIconRef} className="lni lni-calendar"></i>
                    </div>
                    <div className="form-group">
                      <label className="whitetext">Adults</label>
                      <input type="number" defaultValue="1" />
                    </div>
                    <div className="form-group">
                      <label className="whitetext">Children</label>
                      <input type="number" defaultValue="0" />
                    </div>
                    <div className="form-group">
                      <label className="whitetext">Rooms</label>
                      <input type="number" defaultValue="1" />
                    </div>
                    <div className="form-group">
                      <label>&nbsp; </label>
                      <input type="submit" value="Check Availability" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section className="content-section no-spacing kentbghalf desktopview">
          <div className="container">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-6">
                <div className="side-content text-center">
                  <p style={{ fontSize: '3.2rem', padding: '2.3rem 0 2.4rem 0px' }}></p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing desktopview" style={{ background: '#ecdfd7' }}>
          <div className="container">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-6">
                <div className="side-content text-right">
                  <h6>PARADISE FOUND</h6>
                  <h2 className="line" style={{ color: '#722628', fontSize: '41px' }}>
                    Discover Nuwara-Eliya's<br />
                    leading luxury boutique hotel.
                  </h2>
                  <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="custom-button" style={{ marginLeft: '21rem' }}>EXPLORE WITH US</Link>
                </div>
              </div>
              <div className="col-lg-6">
                <figure className="side-image right-full overlap-top reveal-effect">
                  <img src={introImage} alt="relax at kent cottage" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing mobileview" style={{ background: '#ecdfd7' }}>
          <div className="container">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-6">
                <div className="side-content text-center">
                  <h6>PARADISE FOUND</h6>
                  <h2 className="line" style={{ color: '#722628' }}>
                    Discover Nuwara-Eliya's<br />
                    leading luxury boutique hotel.
                  </h2>
                  <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="custom-button">EXPLORE WITH US</Link>
                </div>
              </div>
              <div className="col-lg-6">
                <figure className="side-image right-full overlap-bottom reveal-effect">
                  <img src={introImage} alt="gallery" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section" style={{ background: '#512929', paddingBottom: 0 }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-9 col-12">
                <div className="section-title light">
                  <h6 style={{ color: '#9b8484' }}>ROOMS & SUITES</h6>
                  <h2>Escape to The Misty Highlands</h2>
                </div>
              </div>
              <div className="col-lg-3 col-12 whitetext">
                <a href="/kent/accommodation" className="custom-button-cream roombtn paddingbtn" style={{ marginTop: '1rem' }}>VIEW ALL ROOMS</a>
              </div>
            </div>
          </div>
        </section>

        {/* ROOMS & SUITES Slider Section - DESKTOP */}
        <section className="content-section no-spacing kentbg desktopview" style={{ background: '#512929 !important' }}>
          <div className="rooms-slider" ref={roomsSliderRef}>
            <div className="swiper-wrapper">
              <div className="swiper-slide" style={{ backgroundImage: `url(${kingSuiteImage})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '500px', backgroundColor: '#512929', backgroundBlendMode: 'normal' }}>
                <div className="room-detail">
                  <h3 style={{fontFamily: 'Argesta Display'}}><a href="/kent/room-kingsuite">Loft Suite</a></h3>
                </div>
              </div>
              <div className="swiper-slide" style={{ backgroundImage: `url(${kingRoomImage})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '500px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-kingroom">Master Bedroom</a></h3>
                </div>
              </div>
              <div className="swiper-slide" style={{ backgroundImage: `url(${doubleRoomImage})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '500px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-doubleroom">Deluxe Double Room</a></h3>
                </div>
              </div>
              <div className="swiper-slide" style={{ backgroundImage: `url(${twinRoomImage})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '500px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-twinroom">Deluxe Twin Room</a></h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ROOMS & SUITES Slider Section - MOBILE */}
        <section className="content-section no-spacing kentbg mobileview" style={{ background: '#512929' }}>
          <div className="rooms-slider swiper-container" ref={roomsSliderMobileRef}>
            <div className="swiper-wrapper">
              <div className="swiper-slide" style={{ backgroundImage: `url(${kingSuiteImageMobile})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '350px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-kingsuite">Loft Suite</a></h3>
                </div>
              </div>
              <div className="swiper-slide" style={{ backgroundImage: `url(${kingRoomImageMobile})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '350px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-kingroom">Master Bedroom</a></h3>
                </div>
              </div>
              <div className="swiper-slide" style={{ backgroundImage: `url(${doubleRoomImageMobile})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '350px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-doubleroom">Deluxe Double Room</a></h3>
                </div>
              </div>
              <div className="swiper-slide" style={{ backgroundImage: `url(${twinRoomImageMobile})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '350px' }}>
                <div className="room-detail">
                  <h3><a href="/kent/room-twinroom">Deluxe Twin Room</a></h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FACILITIES Section - DESKTOP */}
<section className="content-section kentbg2 desktopview">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="section-title whitetext">
          <h6 style={{ color: '#985b5b' }}>FACILITIES</h6>
          <h2>
            Enjoy a variety of facilities<br />
            in your very own holiday home
          </h2>
        </div>
      </div>
      <div className="col-12">
        <div className="carousel-image-box swiper-container" ref={facilitiesSliderRef} style={{ margin: '0 -10px' }}>
          <div className="swiper-wrapper">
            <div className="swiper-slide" style={{ width: '22%', padding: '0 10px' }}>
              <figure className="reveal-effect" style={{ margin: 0 }}>
                <img src={facility1} alt="Hot Tub" style={{ width: '100%', height: 'auto' }} />
                <figcaption>
                  <h5>HOT TUB</h5>
                  <p>For the chilly nights</p>
                </figcaption>
              </figure>
            </div>
            <div className="swiper-slide" style={{ width: '22%', padding: '0 10px' }}>
              <figure className="reveal-effect" style={{ margin: 0 }}>
                <img src={facility2} alt="In-house Entertainment" style={{ width: '100%', height: 'auto' }} />
                <figcaption>
                  <h5>IN-HOUSE ENTERTAINMENT</h5>
                  <p>For a cosy, fun night in with friends</p>
                </figcaption>
              </figure>
            </div>
            <div className="swiper-slide" style={{ width: '22%', padding: '0 10px' }}>
              <figure className="reveal-effect" style={{ margin: 0 }}>
                <img src={facility3} alt="Bathtub" style={{ width: '100%', height: 'auto' }} />
                <figcaption>
                  <h5>BATHTUB</h5>
                  <p>For a calm, self-care days</p>
                </figcaption>
              </figure>
            </div>
            <div className="swiper-slide" style={{ width: '22%', padding: '0 10px' }}>
              <figure className="reveal-effect" style={{ margin: 0 }}>
                <img src={facility4} alt="Hidden Gems" style={{ width: '100%', height: 'auto' }} />
                <figcaption>
                  <h5>HIDDEN GEMS</h5>
                  <p>Spot the vintage details</p>
                </figcaption>
              </figure>
            </div>
            <div className="swiper-slide" style={{ width: '22%', padding: '0 10px' }}>
              <figure className="reveal-effect" style={{ margin: 0 }}>
                <img src={facility5} alt="BBQ" style={{ width: '100%', height: 'auto' }} />
                <figcaption>
                  <h5>BBQ</h5>
                  <p>Misty hills, sizzling grills, bliss</p>
                </figcaption>
              </figure>
            </div>
            <div className="swiper-slide" style={{ width: '22%', padding: '0 10px' }}>
              <figure className="reveal-effect" style={{ margin: 0 }}>
                <img src={facility6} alt="Garden" style={{ width: '100%', height: 'auto' }} />
                <figcaption>
                  <h5>GARDEN</h5>
                  <p>For the love of all things botanical and floral</p>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        {/* FACILITIES Section - MOBILE */}
        <section className="content-section kentbg2 mobileview">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title whitetext">
                  <h6 style={{ color: '#985b5b' }}>FACILITIES</h6>
                  <h2>
                    Enjoy a variety of facilities<br />
                    in your very own holiday home
                  </h2>
                </div>
              </div>
              <div className="col-12">
                <div className="carousel-image-box swiper-container" ref={facilitiesSliderMobileRef}>
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <figure className="reveal-effect">
                        <img src={facility1Mobile} alt="Hot Tub" />
                        <figcaption>
                          <h5>HOT TUB</h5>
                          <p>For the chilly nights</p>
                        </figcaption>
                      </figure>
                    </div>
                    <div className="swiper-slide">
                      <figure className="reveal-effect">
                        <img src={facility2Mobile} alt="In-house Entertainment" />
                        <figcaption>
                          <h5>IN-HOUSE ENTERTAINMENT</h5>
                          <p>For a cosy, fun night in with friends</p>
                        </figcaption>
                      </figure>
                    </div>
                    <div className="swiper-slide">
                      <figure className="reveal-effect">
                        <img src={facility3Mobile} alt="Bathtub" />
                        <figcaption>
                          <h5>BATHTUB</h5>
                          <p>For a calm, self-care days</p>
                        </figcaption>
                      </figure>
                    </div>
                    <div className="swiper-slide">
                      <figure className="reveal-effect">
                        <img src={facility4Mobile} alt="Hidden Gems" />
                        <figcaption>
                          <h5>HIDDEN GEMS</h5>
                          <p>Spot the vintage details</p>
                        </figcaption>
                      </figure>
                    </div>
                    <div className="swiper-slide">
                      <figure className="reveal-effect">
                        <img src={facility5Mobile} alt="BBQ" />
                        <figcaption>
                          <h5>BBQ</h5>
                          <p>Misty hills, sizzling grills, bliss</p>
                        </figcaption>
                      </figure>
                    </div>
                    <div className="swiper-slide">
                      <figure className="reveal-effect">
                        <img src={facility6Mobile} alt="Garden" />
                        <figcaption>
                          <h5>GARDEN</h5>
                          <p>For the love of all things botanical and floral</p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section kentbg3 desktopview" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="row no-gutters align-items-center">
              <div className="col-12">
                <div className="section-title text-center whitetext">
                  <h6 style={{ color: '#985b5b' }}>
                    SRI LANKAN CUISINE WITH A BRITISH TOUCH
                  </h6>
                  <h2>Thinking of Indulging?</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing" style={{ background: '#722628' }}>
          <div className="container">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-6">
                <div className="side-content light text-left">
                  <h6>FOOD & BEVERAGE</h6>
                  <h2>An Ode to Flavour</h2>
                  <p>
                    Inviting all our guests to explore an array of flavours in
                    every meal. The cool weather in the mountains invites an
                    indulgence for food and the chefs at Kent Cottage are only too
                    pleased to help satisfy all your cravings.
                  </p>
                  <a href="/kent/dining" className="custom-button roombtn">SEE OUR FOOD & DRINKS MENU</a>
                </div>
              </div>
              <div className="col-lg-6">
                <figure className="side-image right-align overlap-top reveal-effect">
                  <img src={sideImage03} alt="gallery" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        {/* FEELING ADVENTUROUS Section */}
        <section className="content-section" style={{ background: '#905d5f' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title light">
                  <h6>FEELING ADVENTUROUS?</h6>
                  <h2>
                    We can help you build the perfect, personalized itinerary!
                  </h2>
                </div>
              </div>
              <div className="col-12">
                <div className="events-tab">
                  <div id="tab01" className="tab-item active-item">
                    <div className="carousel-events-box swiper-container" ref={adventureSliderRef}>
                      <div className="swiper-wrapper">
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={loversLeapImage} alt="Lover's Leap Waterfall" />
                          </figure>
                          <div className="content">
                            <h5>Lover's Leap Waterfall</h5>
                            <span>3KM Away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={lakeImage} alt="Lake Gregory" />
                          </figure>
                          <div className="content">
                            <h5>Lake Gregory</h5>
                            <span>3.6KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={moonPlainsImage} alt="Moon Plains" />
                          </figure>
                          <div className="content">
                            <h5>Moon Plains</h5>
                            <span>4KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={golfImage} alt="Nuwara Eliya Golf Club" />
                          </figure>
                          <div className="content">
                            <h5>Nuwara Eliya Golf Club</h5>
                            <span>4.5KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={horseImage} alt="Horse riding at Race Course Ground" />
                          </figure>
                          <div className="content">
                            <h5>Horse riding at<br />Race Course Ground</h5>
                            <span>4.7KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={hakgalaImage} alt="Hakgala Botanical Gardens" />
                          </figure>
                          <div className="content">
                            <h5>Hakgala Botanical Gardens</h5>
                            <span>8KM away</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={teaImage} alt="Tea Plantations" />
                          </figure>
                          <div className="content">
                            <h5>Tea Plantations</h5>
                            <span>All around the location</span>
                          </div>
                        </div>
                        <div className="swiper-slide">
                          <figure className="reveal-effect">
                            <img src={teaFactoryImage} alt="Tea Factory Tours" />
                          </figure>
                          <div className="content">
                            <h5>Tea Factory Tours</h5>
                            <span>12.5KM away</span>
                          </div>
                        </div>
                      </div>
                      <div className="swiper-prev"></div>
                      <div className="swiper-next"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing kentbg desktopview" style={{ background: '#722628' }}>
          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-6">
                <figure className="side-image left-full-space">
                  <img src={sideImage} alt="gallery" />
                </figure>
              </div>
              <div className="col-lg-6">
                <div className="spacing-100"></div>
                <div className="side-content whitetext">
                  <h6>Relax, renew, revive</h6>
                  <h2>To know about us,<br />ask those coming back!</h2>
                  <p>
                    We love hearing your feedback. It helps us make sure we are serving you to the best of our ability!
                  </p>
                </div>
                <div className="spacing-100"></div>
                <div className="row inner">
                  <div className="col-md-6 col-6">
                    <figure className="side-image">
                      <img src={sideOne} alt="gallery" />
                    </figure>
                  </div>
                  <div className="col-md-6 col-6">
                    <figure className="side-image">
                      <img src={sideTwo} alt="gallery" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content-section no-spacing desktopview" style={{ background: '#905d5f' }}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bar">
                  <i className="lni lni-protection"></i>
                  <h6>View our reviews from our previous guest on</h6>
                  <a href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905" target="_blank" rel="noopener noreferrer">
                  <strong style={{ color: '#fff' }}>Tripadvisor</strong>
                  </a>
                  <figure>
                    <a href="https://www.tripadvisor.com//Hotel_Review-g608524-d12244042-Reviews-Kent_Cottage-Nuwara_Eliya_Central_Province.html?m=19905" target="_blank" rel="noopener noreferrer">
                      <img src={logoTripadvisor} alt="Tripadvisor reviews of Kent Cottage" />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  );
};

export default Home;